/*
 * Purpose : Page to have all the containers (just as fragment)
 * Author : Soban
 * Copyright (c) - Globalfoundries 
 * 
 * Revision History
 * Version  | Date        | Author  | Description
 * -------------------------------------------------------------------------------------
 * 1.0      | 26-Oct-2021 | Soban   | Initial version
 * 
 */


import React, {Component} from 'react';
import Aux from '../Auxilliary/Auxilliary';

class Layout extends Component {
  state = {
      showSideDrawer: false
  }

//   sideDrawerClosedHandler = () => {
//       this.setState( { showSideDrawer: false } );
//   }

//   sideDrawerToggleHandler = () => {
//       this.setState( ( prevState ) => {
//           return { showSideDrawer: !prevState.showSideDrawer };
//       } );
//   }

  render () {
      return (
          <Aux>
              <main className="Content">
                  {this.props.children}
              </main>
          </Aux>
      )
  }
}

export default Layout;